// extracted by mini-css-extract-plugin
export default {"container":"components-settings-users-tables-cells-cell-role-module__container"};